import { render, staticRenderFns } from "./DefaultAvatar.vue?vue&type=template&id=fc7c4ee8&scoped=true&"
import script from "./DefaultAvatar.vue?vue&type=script&lang=js&"
export * from "./DefaultAvatar.vue?vue&type=script&lang=js&"
import style0 from "./DefaultAvatar.vue?vue&type=style&index=0&id=fc7c4ee8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7c4ee8",
  null
  
)

export default component.exports